<template>
    <div id="printing-explain">
        <div id="printing-explain-line">
            <img class="printing-explain-icon" src="../assets/member_print_description.jpg" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "PrintingExplain"
    }
</script>

<style scoped lang="scss">
    #printing-explain {
        background-color: #FFFFFF;

        #printing-explain-line {
            border: 1px solid #ed3f14;
            margin: 10px;
            border-radius: 10px;
            padding: 10px 20px 10px 20px;

            .printing-explain-icon {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>